import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Div } from 'ui-kit';
import CloseIcon from '@material-ui/icons/Close';

import { Overlay, Wrapper, CloseButton } from './styles';

interface OnboardingCompleteTooltipProps {
  onClose: () => void;
}

const OnboardingCompleteTooltip: FC<OnboardingCompleteTooltipProps> = ({ onClose }) => {
  const { t: locale } = useTranslation('common');

  return (
    <>
      <Overlay />
      <Wrapper>
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>
        <Typography bold variant="body1">
          {locale('common:onboardingCompleteTooltipTitle')}
        </Typography>
        <Div margin={{ top: 8, right: 20 }}>
          <Typography variant="body2">{locale('common:onboardingCompleteTooltipBody')}</Typography>
        </Div>
      </Wrapper>
    </>
  );
};

export default OnboardingCompleteTooltip;
